'use strict'

jQuery(document).ready(function($) {
	console.log('JTF Child Theme Main Script Loaded')

	$('.navigation__floating--share-trigger').click(function () {
		if ( $('.sharebox').hasClass('sharebox--hidden') ) {
			$('.sharebox').removeClass('sharebox--hidden')
			$('.sharebox').addClass('sharebox--visible')
		} else {
			$('.sharebox').removeClass('sharebox--visible')
			$('.sharebox').addClass('sharebox--hidden')
		}
	})
	/**
	 * Parallax the rings on scroll
	 */
	$(window).scroll(function(){
		let distanceFromTop = $(document).scrollTop();
		
		$('.par__ring--1').css({transform: 'translateY('+distanceFromTop*0.8+'px)'})
		$('.par__ring--2').css({transform: 'translateY('+distanceFromTop*0.5+'px)'})
		$('.par__ring--3').css({transform: 'translateY('+distanceFromTop*0.9+'px)'})
	});

	/**
	 * R4R mobile menu
	 */
	const r4rSubMenu 			= 'navigation__r4rsubmenu';
	const r4rSubMenuList 		= r4rSubMenu + '--list';
	const r4rSubMenuTrigger 	= r4rSubMenu + '__mobile__trigger';
	const r4rSubMenuTriggerOpen = r4rSubMenuTrigger + '--open';

	function openMenu( trigger ) {
		$( '.' + r4rSubMenuList ).show();
		$( trigger ).addClass( r4rSubMenuTriggerOpen );
	}

	function closeMenu( trigger ) {
		$( '.' + r4rSubMenuList ).hide();
		$( trigger ).removeClass( r4rSubMenuTriggerOpen );
	}

	$( window ).resize( function () {
		if ( 991 < window.innerWidth ) {
			openMenu( '.' + r4rSubMenuTrigger );
		} else {
			closeMenu( '.' + r4rSubMenuTrigger );
		}
	});

	$( document ).ready( function () {
		if ( 991 < window.innerWidth ) {
			openMenu( '.' + r4rSubMenuTrigger );
		} else {
			closeMenu( '.' + r4rSubMenuTrigger );
		}
	});

	$( '.' + r4rSubMenuTrigger ).click( function () {
		if ( $( this ).hasClass( r4rSubMenuTriggerOpen ) ) {
			closeMenu( this );
		} else {
			openMenu( this );
		}
	});
});
